var module = angular.module('sdLocalStorageHelper', ['ngStorage']);
module.service('sdLocalStorageHelper', ["$localStorage", function ($localStorage) {
    var NG_STORAGE_PREFIX = 'ngStorage-';

    function readFromSessionStorage(objName) {
        try {
            var raw = sessionStorage.getItem(NG_STORAGE_PREFIX + objName);
            return raw ? JSON.parse(raw) : undefined;
        } catch (e) {
            return undefined;
        }
    }

    function writeToSessionStorage(objName, data) {
        try {
            sessionStorage.setItem(NG_STORAGE_PREFIX + objName, JSON.stringify(data));
        } catch (e) {
            // Storage blocked in this context (e.g. Safari with cookies disabled, private mode)
        }
    }

    return {
        get: function (objName, dataObject) {
            var data = $localStorage[objName];
            if (null === data || typeof data === 'undefined') {
                data = readFromSessionStorage(objName);
            }
            if ((null !== data && typeof data !== 'undefined') && typeof dataObject !== 'undefined') {
                angular.forEach(dataObject, function(value, key) {
                    dataObject[key] = data[key] || dataObject[key];
                });
                angular.forEach(data, function(value, key) {
                    dataObject[key] = data[key] || dataObject[key];
                });
            }
            return dataObject;
        },
        set: function (objName, data) {
            $localStorage[objName] = data;
            writeToSessionStorage(objName, data);
        },
        reset: function () {
            $localStorage.$reset();
            try {
                Object.keys(sessionStorage)
                    .filter(function (key) { return key.indexOf(NG_STORAGE_PREFIX) === 0; })
                    .forEach(function (key) { sessionStorage.removeItem(key); });
            } catch (e) {
                // Storage blocked in this context (e.g. Safari with cookies disabled, private mode)
            }
        }
    }
}]);
